import {
  CLEAN_USERS,
  DELETE_USER,
  GET_USERS,
  GET_USER,
  SAVE_USER,
  GET_PROFILE,
  SET_RELOAD_USERS,
  SET_USER_FILTERS,
  SET_CURRENT_USER_STEP, ADD_COMPLETED_USER_STEPS, SET_COMPLETED_USER_STEPS,
  SET_USER_ATTRIBUTES
} from './types';
import {
  createUserQuery, deleteUserQuery, getProfileQuery, getUserQuery, listUsersQuery, updateUserQuery
} from '../../graphql';
import api from '../../apiClient';

export function getUsers(variables = {}) {
  return {
    type: GET_USERS,
    payload: api.graphql(listUsersQuery, variables)
  };
}

export function getProfile() {
  return {
    type: GET_PROFILE,
    payload: api.graphql(getProfileQuery)
  };
}

export function getUser(id) {
  return {
    type: GET_USER,
    payload: api.graphql(getUserQuery, { id })
  };
}

export function saveUser(variables = {}) {
  const query = variables.input.id ? updateUserQuery : createUserQuery;
  return {
    type: SAVE_USER,
    payload: api.graphql(query, variables)
  };
}

export function cleanUsers(extraProps = {}) {
  return {
    type: CLEAN_USERS,
    payload: Promise.resolve(extraProps)
  };
}

export function deleteUser(id) {
  return {
    type: DELETE_USER,
    payload: api.graphql(deleteUserQuery, { id })
  };
}

export function setReloadUsers(reload) {
  return {
    type: SET_RELOAD_USERS,
    payload: { reload }
  };
}

export function setUserFilters(filters) {
  return {
    type: SET_USER_FILTERS,
    payload: { filters }
  };
}

export function setCurrentUserStep(step) {
  return {
    type: SET_CURRENT_USER_STEP,
    payload: { step }
  };
}

export function setCompletedUserSteps(steps) {
  return {
    type: SET_COMPLETED_USER_STEPS,
    payload: { steps }
  };
}

export function addCompletedUserSteps(...steps) {
  return {
    type: ADD_COMPLETED_USER_STEPS,
    payload: { steps }
  };
}

export function setUserAttributes(userId, attributes = {}) {
  return {
    type: SET_USER_ATTRIBUTES,
    payload: { userId, attributes },
  };
}
